import { Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";

export function NotFound() {
  return (
    <div className="relative grid min-h-dvh place-items-center overflow-hidden bg-background">
      <div className="relative z-10 px-6 text-center">
        <div className="select-none font-mono font-bold leading-none text-muted-foreground/40 text-[clamp(8rem,20vw,14rem)] tracking-tighter">
          404
        </div>
        <div
          aria-hidden
          className="mx-auto -mt-8 mb-8 h-px w-12 bg-gradient-to-r from-transparent via-primary to-transparent"
        />
        <h1 className="mb-3 font-display text-2xl font-semibold tracking-tight">Page not found</h1>
        <p className="mb-10 text-sm leading-relaxed text-muted-foreground">
          The page you&rsquo;re looking for doesn&rsquo;t exist or has been moved.
        </p>
        <Link
          to="/sites"
          className="inline-flex items-center gap-2 rounded-sm border border-primary/30 bg-primary/10 px-5 py-2.5 text-sm font-medium text-primary transition-all hover:bg-primary/20"
        >
          <ArrowLeft className="size-4" /> Back to sandbar
        </Link>
        <p className="mt-16 font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground/60">
          sandbar &middot; route not resolved
        </p>
      </div>
    </div>
  );
}
